import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import FundingTypesNew from "./fundingtypesnew";
import PropertyEdit from "./propertyedit";
import useApi from "../../../../hooks/use-api";
import formatDollars from "../../../../utilities/currency-formatter";
import { useOutletContext } from "react-router-dom";

const HousingNew = ({}) => {
    const{ApplicationID} = useOutletContext();
    const [selectedProperty,setSelectedProperty] = useState(null);
    const [isLoading,setIsLoading] = useState(true);
    const [fundingTypes,setFundingTypes] = useState([]);
    const [states,setStates] = useState([]);
    const [actions,setActions] = useState([]);
    const [inspectionStatuses,setInspectionStatuses] = useState([]);
    const [inspectionTypes,setInspectionTypes] = useState([]);
    const [formValues,setFormValues] = useState();
    const [properties,setProperties] = useState([]);

    const {getRequest} = useApi();

    const getAll = async() => {
        setIsLoading(true);

        const [definitionData,housingData] = await Promise.all([
            getRequest('HousingDefinitions'),
            getRequest('Housing',{ApplicationID: ApplicationID,timestamp: Date.now()})
        ]);

        setIsLoading(false);

        const [extractedDefinitionData,definitionStatus] = definitionData;
        const [extractedHousingData,housingStatus] = housingData;

        if(definitionStatus === 200 && housingStatus === 200){
            setFundingTypes(extractedDefinitionData.housingfundingtypes);
            setProperties(extractedHousingData.properties);
            setStates(extractedDefinitionData.states);
            setActions(extractedDefinitionData.actions);
            setInspectionTypes(extractedDefinitionData.inspectiontypes);
            setInspectionStatuses(extractedDefinitionData.inspectionstatuses);

            setFormValues({
                fundingtypes: extractedHousingData.housingfundingtypes,
                fundingtypeother: extractedHousingData.housingfundingtypesother === null ? '' : extractedHousingData.housingfundingtypesother
            });
        }
    }

    const _silentRefresh = async () => {
        const [data,status] = await getRequest('Housing',{ApplicationID: ApplicationID,timestamp: Date.now()});

        if(status === 200){
            setProperties(data.properties);

            setFormValues({
                fundingtypes: data.housingfundingtypes,
                fundingtypeother: data.housingfundingtypesother === null ? '' : data.housingfundingtypesother
            });
        }
    }

    useEffect(() => {
        getAll();
    },[])

    if(isLoading){
        return(
            <div>loading</div>
        )
    }

    if(selectedProperty){
        return(
            <PropertyEdit
                PropertyID={selectedProperty}
                ApplicationID={ApplicationID}
                ReturnFunction={() => setSelectedProperty(null)}
                RefreshFunction={_silentRefresh}
                States={states}
                Actions={actions}
                InspectionStatuses={inspectionStatuses}
                InspectionTypes={inspectionTypes}
            />
        )
    }

    const getStateName = (stateId) => states.find(st => st.id === stateId)?.name;

    return(
        <Row>
            <Col xs={12} className="mb-3">
                <div className="clientCard">
                    <div className="clientCardInner">
                        <h4 className="text-center">Housing</h4>
                        <FundingTypesNew ApplicationID={ApplicationID} FundingTypes={fundingTypes} formValues={formValues} ResetSelectedFundingTypes={(data) => setFormValues(data)}/>
                    </div>
                </div>
            </Col>
            <Col xs={12}>
                <h4 className="text-center">Properties</h4>
                <Row>
                    {properties.map((prop) => (
                        <Col xs={12} md={4} key={prop.id}>
                            <div className="clientCard">
                                <div className="ccHeader">
                                    <div className="ccHeaderInner">
                                        <h5 className="mb-0">
                                            {prop.address}
                                        </h5>
                                    </div>
                                </div>
                                <div className="ccBody">
                                    <div style={{maxHeight: '250px',overflowY: 'auto'}}>
                                        <h6 className="mb-0 mt-2">Address</h6>
                                        <p className="mb-2">{prop.address}</p>
                                        <h6 className="mb-0">City</h6>
                                        <p className="mb-2">{prop.city}</p>
                                        <h6 className="mb-0">State</h6>
                                        <p className="mb-2">{getStateName(prop.state)}</p>
                                        <h6 className="mb-0">Zip</h6>
                                        <p className="mb-2">{prop.zip}</p>
                                        <h6 className="mb-0">Name</h6>
                                        <p className="mb-2">{prop.name}</p>
                                        <h6 className="mb-0">Phone</h6>
                                        <p className="mb-2">{prop.phone}</p>
                                        <h6 className="mb-0">Email</h6>
                                        <p className="mb-2">{prop.email}</p>
                                        <h6 className="mb-0">PVA Value</h6>
                                        <p className="mb-2">{prop.pvavalue ? formatDollars(prop.pvavalue) : 'N/A'}</p>
                                    </div>
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button type="button" variant="primary" onClick={() => setSelectedProperty(prop.id)}>View/Edit</Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    )
}

export default HousingNew;
